import React from 'react'
import ECCNListPage from './ECCNListPage'

const ECCNBreadcrumb = () => <>ECCN</>

const eccnRoutes = [
  {
    breadcrumb: ECCNBreadcrumb,
    path: '',
    element: <ECCNListPage />,
    children: [],
  },
]

export default eccnRoutes
